import { HttpContextToken } from "@angular/common/http";

// Marca requisicoes que NAO devem disparar a barra/spinner de progresso global (NProgress).
// O fluxo de login tem seu proprio indicador unico (spinner dentro do botao "Entrar"),
// entao suas requisicoes setam este token para suprimir o loader global SOMENTE nelas.
// Todas as demais telas continuam usando o NProgress normalmente.
export const SKIP_PROGRESS = new HttpContextToken<boolean>(() => false);
